import {createStore} from 'vuex';
import AuthModule from './modules/auth';
import AppModule from './modules/app';
import SocketModule from './modules/socket';


const store = createStore({
  modules:{
    auth:AuthModule,
    app:AppModule,
    socket:SocketModule
  }
});

export default store;
